export default "__VITE_ASSET__028d4345__"